import { PSEUDO_ID_COOKIE } from "@/platform/api/constants"
import type { SessionGateway } from "@/platform/api/gateways/session"
import { clearSessionCookie } from "@/platform/session/auth/get-session-cookie-client"
import { abortSessionLookups, commitSession, supersedeSession } from "@/platform/session/publisher"
import { setRevocation } from "@/platform/session/revocation"
import { announceSessionChange } from "@/platform/session/sync"
import { setStoredWishlist } from "@/platform/shopper/use-wishlist-id"

import type { QueryClient } from "@tanstack/react-query"

export const logout = async (queryClient: QueryClient, sessions: Pick<SessionGateway, "revoke">): Promise<void> => {
  supersedeSession(queryClient)
  setRevocation(queryClient, "pending")
  await abortSessionLookups(queryClient)
  try {
    await sessions.revoke()
  } catch (error) {
    setRevocation(queryClient, "failed")
    throw error
  }
  clearSessionCookie(PSEUDO_ID_COOKIE)
  setStoredWishlist(null)
  await abortSessionLookups(queryClient)
  commitSession(queryClient, { kind: "anonymous" })
  setRevocation(queryClient, "none")
  announceSessionChange()
}
